var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClicPlayError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 220,
    viewBox: "0 0 216 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.6 71.2383V148.762L157.2 110.085L102.6 71.2383Z",
    fill: "#F8A51B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.29 145.619L216 168.276C205.114 185.096 189.667 198.886 171.34 207.999C171.285 208.027 171.229 208.056 171.174 208.083C170.503 208.417 169.827 208.739 169.146 209.059C168.725 209.255 168.302 209.452 167.876 209.643L167.48 209.824C152.955 216.352 136.773 220 119.728 220C91.9433 220 66.4538 210.314 46.6801 194.248C47.6606 193.463 48.6123 192.608 49.5352 191.685C55.8451 185.376 59 177.814 59 169C59 160.186 55.8451 152.674 49.5352 146.465C43.3255 140.155 35.8138 137 27 137C20.991 137 15.564 138.466 10.7189 141.399C7.64915 131.446 6 120.907 6 110.002C6 49.3459 57.0176 0 119.728 0C119.76 0 119.793 0.000397473 119.825 0.000797458C119.858 0.00120254 119.891 0.00161019 119.925 0.00161019C120.705 0.00483057 121.486 0.0128815 122.262 0.0305936C122.31 0.0322038 122.359 0.0334114 122.408 0.0346191C122.456 0.0358267 122.505 0.0370344 122.553 0.0386446C161.477 1.03857 195.59 21.0387 215.321 50.7773L169.223 73.1074C157.744 58.6818 139.72 49.3668 119.485 49.3668C84.8903 49.3668 56.7462 76.5919 56.7462 110.053C56.7462 143.515 84.8903 170.736 119.485 170.736C140.358 170.736 158.878 160.826 170.29 145.619Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.662 171.662V155.437H24.338V171.662H29.662ZM29.662 182.563V177.113H24.338V182.563H29.662ZM7.85915 149.986C13.1831 144.662 19.5634 142 27 142C34.4366 142 40.7746 144.662 46.0141 149.986C51.338 155.225 54 161.563 54 169C54 176.437 51.338 182.817 46.0141 188.141C40.7746 193.38 34.4366 196 27 196C19.5634 196 13.1831 193.38 7.85915 188.141C2.61972 182.817 0 176.437 0 169C0 161.563 2.61972 155.225 7.85915 149.986Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClicPlayError);
export default __webpack_public_path__ + "static/media/clic_play_error.8ed54e1dd3202da5e89e3b8142fb332a.svg";
export { ForwardRef as ReactComponent };